import { useState, useContext } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { LoginContext } from 'components/login/loginContext'
import { TransparentButton, FlexRow } from 'components/common/common_styles'
import useIsScrolled from 'components/common/useIsScrolled'
import HamburgerMenu from 'svgs/HamburgerMenu.svg'
import CloseButton from 'svgs/CloseButton.svg'
import AccountIcon from 'svgs/AccountIcon.svg'
import Logo from 'svgs/SnowPeakLogo.svg'
import InstagramIcon from 'components/icons/instagramIcon'
import FacebookIcon from 'components/icons/facebookIcon'
import TwitterIcon from 'components/icons/twitterIcon'
import { MainContainer, MenuContainer, MenuHeader, Arrow, IconContainer, LogoLink, AccountLink, BookButton } from './mobileMenu_styles'

const MobileMenu = ({ $home }) => {
  const { prismicMainMenu: { data } } = useStaticQuery(query)
  const { userDetails } = useContext(LoginContext)
  const [menuOpen, setMenuOpen] = useState(false)
  const isScrolled = useIsScrolled()

  const toggleMenuOpen = () => {
    setMenuOpen(oldVal => !oldVal)
  }

  return (
    <>
      <MainContainer isScrolled={isScrolled}>
        <FlexRow center>
          <TransparentButton onClick={toggleMenuOpen}>
            <HamburgerMenu stroke={isScrolled ? '#171717' : 'white'} />
          </TransparentButton>
          <AccountLink to='/account' $isScrolled={isScrolled} aria-label='account'>
            <AccountIcon fill={isScrolled ? '#171717' : 'white'} />
            <p>{userDetails?.first_name}</p>
          </AccountLink>
        </FlexRow>
        <LogoLink to='/' $home={$home}>
          <Logo fill={isScrolled ? '#171717' : 'white'} />
        </LogoLink>
        <BookButton link='/booking' $isScrolled={isScrolled}>BOOK NOW</BookButton>
      </MainContainer>
      {menuOpen &&
        <MenuContainer>
          <MenuHeader>
            <Link to='/' onClick={() => setMenuOpen(false)}>
              <Logo fill='#171717' />
            </Link>
            <TransparentButton onClick={toggleMenuOpen}>
              <CloseButton />
            </TransparentButton>
          </MenuHeader>
          <ul>
            {data.body.map(menu =>
              <MenuGroup key={menu.id} menu={menu} setMenuOpen={setMenuOpen} />
            )}
          </ul>
          <IconContainer>
            <a href='https://www.instagram.com' target='_blank' rel='noreferrer noopener'>
              <InstagramIcon />
            </a>
            <a href='https://www.facebook.com' target='_blank' rel='noreferrer noopener'>
              <FacebookIcon />
            </a>
            <a href='https://www.twitter.com' target='_blank' rel='noreferrer noopener'>
              <TwitterIcon />
            </a>
          </IconContainer>
        </MenuContainer>
      }
    </>
  )
}

export default MobileMenu

const MenuGroup = ({ menu, setMenuOpen }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => {
    setIsOpen(oldVal => !oldVal)
  }

  return (
    <>
      <li>
        {menu.primary.primary_nav_link ?
          <Link to={`/${menu.primary.primary_nav_link}`} onClick={() => setMenuOpen(false)}>
            <h3>{menu.primary.primary_nav_label}</h3>
          </Link>
          :
          <TransparentButton onClick={toggleOpen}>
            <h3>
              {menu.primary.primary_nav_label}
              <Arrow>▾</Arrow>
            </h3>
          </TransparentButton>
        }
      </li>
      {isOpen && menu.items.map(submenu =>
        <li key={submenu.sub_nav_label}>
          {submenu.sub_nav_link ?
            <Link to={`/${submenu.sub_nav_link}`} onClick={() => setMenuOpen(false)}>
              <h4>{submenu.sub_nav_label}</h4>
            </Link>
            :
            <h4>
              {submenu.sub_nav_label}
            </h4>
          }
        </li>
      )}
    </>
  )
}

export const query = graphql`
  query {
    prismicMainMenu {
      data {
        body {
          ... on PrismicMainMenuDataBodyPrimaryAndSubNavItem {
            id
            items {
              sub_nav_label
              sub_nav_link
            }
            primary {
              primary_nav_label
              primary_nav_link
            }
          }
        }
      }
    }
  }
`
